import React, { useMemo } from 'react';
import { Typography, Dialog, DialogContent, DialogTitle, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import History from 'components/common/History';
import { useLazyGetPsychologyAssessmentHistoryQuery } from 'store/services/pshychologicalAssessment';

const actions = [
    {
        label: 'Create',
        value: 'create'
    },
    {
        label: 'Update',
        value: 'update'
    },
    {
        label: 'Delete',
        value: 'delete'
    },

];

export default function HistoryViewModal({ historyId, handleClose }) {
    const open = Boolean(historyId);

    const historyData = useLazyGetPsychologyAssessmentHistoryQuery();

    const historyPayload = useMemo(
        () => ({
            filters: {
                psychological_testing_id: historyId
            }
        }),
        [historyId]
    );

    return (
        <>
            <Dialog open={open} fullWidth maxWidth="md" onClose={handleClose}>
                <DialogTitle sx={{ p: 2 }}>
                    <Typography variant="h4">Psychological Testing History</Typography>
                    <IconButton
                        onClick={handleClose}
                        sx={{ position: 'absolute', top: 10, right: 10, color: (theme) => theme.palette.grey[500] }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ m: 0, pt: 1 }}>
                    {historyId && <History data={historyData} payload={historyPayload} actions={actions} />}
                </DialogContent>
            </Dialog>
        </>
    );
}
